import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@dhn/lib/utils";

const getBranchInfo = (branchProfile = {}) => {
  const id = branchProfile.branchOfficeId;
  const name = branchProfile.branchOfficeName || branchProfile.name || "";
  const code = branchProfile.branchOfficeCode || branchProfile.code || id;
  const initials =
    name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "?";

  return { id, name, code, initials };
};

function BranchRow({ branch, className, children }) {
  return (
    <>
      <span className={cn("doctor-office-branch__avatar", className)}>
        {branch.initials}
      </span>
      <span className="doctor-office-branch__info">
        <span className="doctor-office-branch__name">{branch.name}</span>
        <small className="doctor-office-branch__code">{`Código ${branch.code}`}</small>
      </span>
      {children}
    </>
  );
}

export default function BranchDropdown({
  branchOfficeOption,
  currentBranchName,
  selectedBranchId,
  onChangeBranch,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointerDown = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [isOpen]);

  if (!branchOfficeOption?.length) return null;

  const isSelected = (branchProfile) =>
    String(branchProfile.branchOfficeId) === String(selectedBranchId);
  const currentProfile = branchOfficeOption.find(isSelected);
  const currentBranch = currentProfile
    ? getBranchInfo(currentProfile)
    : { ...getBranchInfo({ name: currentBranchName }), code: "-" };
  const otherBranches = branchOfficeOption.filter(
    (branchProfile) => !isSelected(branchProfile),
  );
  const canChange = otherBranches.length > 0;

  return (
    <div className="doctor-office-branch" ref={dropdownRef}>
      <button
        type="button"
        className={cn("doctor-office-branch__current", isOpen && "is-open")}
        onClick={() => setIsOpen((value) => !value)}
        disabled={!canChange}
        aria-expanded={isOpen}
        aria-label={`Sucursal activa: ${currentBranch.name}`}
      >
        <BranchRow branch={currentBranch} className="is-active">
          {canChange && (
            <span className="doctor-office-branch__change">
              Cambiar
              <ChevronDown size={14} className="doctor-office-branch__chevron" />
            </span>
          )}
        </BranchRow>
      </button>

      {isOpen && (
        <div className="doctor-office-branch__list" role="menu">
          {otherBranches.map((branchProfile) => {
            const branch = getBranchInfo(branchProfile);

            return (
              <button
                type="button"
                key={branch.id}
                className="doctor-office-branch__option"
                onClick={() => {
                  onChangeBranch(branchProfile);
                  setIsOpen(false);
                }}
                role="menuitem"
              >
                <BranchRow branch={branch}>
                  <i
                    className="fa fa-exchange doctor-office-branch__option-icon"
                    aria-hidden="true"
                  />
                </BranchRow>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
